import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import { MySnackbarContentWrapper } from '../snackbar.utils'

/**
 *
 * @author Huong Nguyen
 */

function SnackbarComponent(props) {
  const { open, onClose, message, variant, autoHideDuration } = props

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
    >
      <MySnackbarContentWrapper
        onClose={onClose}
        variant={variant}
        message={message}
      />
    </Snackbar>
  )
}

export default SnackbarComponent
